import React from "react";

import css from "./Area.module.scss";

export const Area: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={css.Area}>{children}</div>
);
